import style from '../css/Report.module.css';
import Header from './Header';
import ViewContainer from './ViewContainer';

function PrintDocumentSetting(jsonData) {
    return (
        <div className={style.container}>
            <Header />
            <ViewContainer jsonData={jsonData} />
        </div>
    );
}

export default PrintDocumentSetting;
